import { CreditReport as CanadaCreditReportPb } from "@repo/protobuf/gen/kikoff_canada/protobuf/models/credit/credit_report_pb";
import { CreditV2 as UsaCreditV2Pb } from "@repo/protobuf/gen/web/public/credit_pb";
import Protobuf from "@repo/protobuf/utils";
import Address from "@repo/utils/Address";
import FullName from "@repo/utils/FullName";
import UDate from "@repo/utils/UDate";

import { AddressUsa } from "../Address.js";
import { FullNameCanada, FullNameUsa } from "../FullName.js";

import ReportAccount, {
  ReportAccountCanada,
  ReportAccountUsa,
} from "./ReportAccount.js";

type CreditReport = {
  id: CreditReport.Id;
  generatedAt: Date;
  accounts: ReportAccount[];
  name: FullName;
  dateOfBirth: string;
  address: Address;
  previousAddresses: Address[];
};

namespace CreditReport {
  export type Id = string & {};
}

export default CreditReport;

export namespace CreditReportUsa {
  export function normalize(proto: UsaCreditV2Pb): CreditReport {
    return {
      id: proto.generatedDate!.seconds.toString(),
      generatedAt: Protobuf.Timestamp.toDate(proto.generatedDate!),
      accounts: proto.accounts.map(ReportAccountUsa.normalize),
      name: FullNameUsa.normalize(proto.personalInfo?.fullName!),
      dateOfBirth: UDate.format(
        Protobuf.Timestamp.toNumber(proto.personalInfo?.dateOfBirth!),
        "mm/dd/yyyy"
      ),
      address: AddressUsa.normalize(proto.address?.currentAddress!),
      previousAddresses: proto.address?.previousAddresses.map(
        AddressUsa.normalize
      )!,
    };
  }
}

export namespace CreditReportCanada {
  export function normalize(proto: CanadaCreditReportPb): CreditReport {
    return {
      id: proto.id,
      generatedAt: Protobuf.Timestamp.toDate(proto.generatedAt!),
      accounts: proto.accounts.map(ReportAccountCanada.normalize),
      name: FullNameCanada.normalize(proto.name!),
      dateOfBirth: proto.dateOfBirth,
      address: proto.address!,
      previousAddresses: proto.previousAddresses,
    };
  }
}
